import type { ApiPaginatedResponse, ApiResponse } from '@bcube/shared';
import { api } from '@/lib/api';
import type { ITechnology } from '@/types/production/tool';

// Re-export ITechnology from types for convenience
export type { ITechnology };

export interface PaginatedResponse<T> {
  docs: T[];
  total: number;
  page: number;
  pages: number;
  limit: number;
}

export const technologyApi = {
  findMany: async (params?: unknown): Promise<PaginatedResponse<ITechnology>> => {
    const { data } = await api.get<ApiPaginatedResponse<ITechnology>>('/production/technologies', {
      params,
    });
    // Transform created_at from string to Date
    return {
      docs: data.data.map((tech) => ({
        ...tech,
        created_at:
          tech.created_at && typeof tech.created_at === 'string'
            ? new Date(tech.created_at)
            : tech.created_at,
      })),
      total: data.meta.total,
      page: data.meta.page,
      pages: data.meta.pages,
      limit: data.meta.limit,
    };
  },

  findOne: async (id: string): Promise<ITechnology> => {
    const { data } = await api.get<ApiResponse<ITechnology>>(`/production/technologies/${id}`);
    // Transform created_at from string to Date
    return {
      ...data.data,
      created_at:
        data.data.created_at && typeof data.data.created_at === 'string'
          ? new Date(data.data.created_at)
          : data.data.created_at,
    };
  },
};
